import { render, staticRenderFns } from "./FixturesManager.vue?vue&type=template&id=f6250f4e"
import script from "./FixturesManager.vue?vue&type=script&lang=js"
export * from "./FixturesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports